import { CurrencyAdjustmentService } from './../../features/currency-adjustment/services/currency-adjustment.service';
import {
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
// import { LayoutComponent } from '../../core/layout/layout.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
// import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { DialogRef } from '@angular/cdk/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { Store } from '@ngrx/store';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
// import * as selectPermissions from '../../core/permissions/permission.selector';


@Component({
  selector: 'app-currency-adjustments',
  standalone: true,
  imports: [CommonModule, 
    // LayoutComponent, 
    AgGridAngular, RouterModule, 
    // PermissionDirective
  ],
  templateUrl: './currency-adjustments.component.html',
  styleUrl: './currency-adjustments.component.scss',
})
export class CurrencyAdjustmentsComponent implements OnInit {
  columnDefs: ({ headerName: string; field: string; flex: number; cellRenderer?: undefined; floatingFilter?: undefined; filter?: undefined; } | { field: string; headerName: string; flex: number; cellRenderer: (params: any) => HTMLDivElement; floatingFilter: boolean; filter: boolean; })[];
  // profileName: any;
  // Permission = Permission;
  constructor(
    private router: Router,
    private currencyService: CurrencyAdjustmentService,
    private toastr: ToastrService,
    private permissionService: PermissionService,
    // private store: Store,
  ) {
    // const loggedInUser: any = localStorage.getItem('loggedInUser');
    // const userData = JSON.parse(loggedInUser);
    // this.profileName = userData?.profileData?.profileName;
   }

  isDropdownOpen = false;
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public loading: boolean = true;
  public error: any = null;
  private searchSubject = new Subject<string>();
  canListCurrency$ = this.permissionService.hasPermission(
    ModuleIds.Currency,
    'List'
  );
  canCreateCurrency$ = this.permissionService.hasPermission(
    ModuleIds.Currency,
    'Create'
  );
canEditCurrency$ = this.permissionService.hasPermission(
    ModuleIds.Currency,
    'Edit'
  );
  canDeleteCurrency$ = this.permissionService.hasPermission(
    ModuleIds.Currency,
    'Delete'
  );
  canExchangeRateCurrency$ = this.permissionService.hasPermission(
    ModuleIds.Currency,
    'Exchange Rate Logs'
  );
  canDeleteCurrency: boolean = false;
    canEditCurrency: boolean = false;
    canExchangeRateCurrency: boolean = false;
  readonly dialog = inject(MatDialog);

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {

    this.columnDefs = [
      {
        headerName: 'Currency Code',
        field: 'currencyCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      { headerName: 'Currency Name', field: 'currencyName', flex: this.viewPortSize ? 1 : 0 },
      // { headerName: 'Currency Symbol', field: 'currencySymbol', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Exchange Rate', field: 'exchangeRate', flex: this.viewPortSize ? 1 : 0 },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';

          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');

          const deleteIcon = document.createElement('img');
          deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          deleteIcon.style.cursor = 'pointer';
          deleteIcon.setAttribute('data-action', 'delete');
          if(this.canEditCurrency){
          container.appendChild(editIcon);
          }
          if(this.canDeleteCurrency){
          container.appendChild(deleteIcon);
          }

          // this.store.select(selectPermissions.hasPermission('30', Permission.Edit)).subscribe((canEdit) => {
          //   if (canEdit) {
              // container.appendChild(editIcon);
          //   }
          // });
        // this.store.select(selectPermissions.hasPermission('30', Permission.Delete)).subscribe((canDelete) => {
        //     if (canDelete) {
              // container.appendChild(deleteIcon);            }
        //   });

          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';

  ngOnInit(): void {
    this.fetchCurrencyData();

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchCurrencyData(searchTerm);
      });

    this.checkViewportSize();
    this.canEditCurrency$.subscribe(val => {
      this.canEditCurrency = val;
    });
    this.canDeleteCurrency$.subscribe(val => {
      this.canDeleteCurrency = val;
    });
    this.canExchangeRateCurrency$.subscribe(val => {
      this.canExchangeRateCurrency = val;
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  fetchCurrencyData(search: string = '', filter: any = {}) {
    this.loading = true;
    this.currencyService.fetchCurrencies(search, filter).subscribe({
      next: (currencies) => {
        this.rowData = currencies.map((currency: any) => {
          return {
            id: currency?.id,
            currencyCode: currency?.currencyCode,
            currencyName: currency?.currencyName,
            currencySymbol: currency?.currencySymbol,
            exchangeRate: currency?.exchangeRate.toFixed(2),
            isPrimary: currency?.isPrimary,
          };
        });
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching currencies:', err);
        this.loading = false;
      },
    });
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  openUploadDialog() {
    const dialogRef = this.dialog.open(UploadAdjustmentsDialog);
    dialogRef.afterClosed().subscribe((data) => {
      this.fetchCurrencyData();
    });
  }

  openAddCurrencyDialog() {
    const dialogRef = this.dialog.open(AddCurrencyDialogComponent, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.fetchCurrencyData();
      }
    });
  }

  openEditDialog(currencyData: any) {
    console.log('currencyData::', currencyData);
    const dialogRef = this.dialog.open(AddCurrencyDialogComponent, {
      data: currencyData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.fetchCurrencyData();
      }
      dialogRef.close();
    });
  }

  onDeleteCurrency(currencyData: any): void {
    if (currencyData.isPrimary) {
      this.toastr.error('Primary currency cannot be deleted.');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeCurrency(currencyData?.id);
      }
    });
  }

  private removeCurrency(currencyId: number): void {
    this.currencyService.removeCurrencyById(currencyId).subscribe({
      next: () => {
        this.toastr.success(
          'Currency adjustment removed successfully.'
        );
        this.fetchCurrencyData();
      },
      error: (err) => {
        console.log("Failed to remove currency adjustment. Please try again.", err)
        const errorMessage =
          err.message || 'Failed to remove currency adjustment. Please try again.';
        this.toastr.error(errorMessage);
      },
    });
  }

  onCellClicked(params: any) {
    const currencyId = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        if (params?.data?.isPrimary) {
          this.toastr.warning('Primary currencies cannot be edited.');
        } else {
          this.openEditDialog(params?.data);
        }
      } else if (action === 'delete') {
        this.onDeleteCurrency(params?.data);
      }
    } else if(this.canExchangeRateCurrency) {
      this.router.navigate([
        `currency-adjustments/exchange-logs/${currencyId}`,
      ]);
    }
  }
}

@Component({
  selector: 'app-add-currency',
  standalone: true,
  imports: [
    CommonModule,
    // LayoutComponent,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatDialogModule,
  ],
  templateUrl: './add-currency-dialog.html',
  styleUrl: './add-currency-dialog.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddCurrencyDialogComponent implements OnInit {
  addCurrencyForm!: FormGroup;
  successMessage: string | null = null;
  errorMessage: string | null = null;
  loading: boolean = false;
  currencyData: any;

  constructor(
    private currencyService: CurrencyAdjustmentService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddCurrencyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.currencyData = this.data;
    }
    this.initForm();
  }

  initForm(): void {
    this.addCurrencyForm = this.fb.group({
      id: [this.currencyData?.id || ''],
      currencyCode: [
        this.currencyData?.currencyCode || '',
        [Validators.required, this.noWhitespaceValidator()]
      ],
      currencyName: [
        this.currencyData?.currencyName || '',
        [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]
      ],
      currencySymbol: [
        this.currencyData?.currencySymbol || '',
        [ this.noWhitespaceValidator()]
      ],
      exchangeRate: [
        this.currencyData?.exchangeRate || '',
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), this.noWhitespaceValidator()]
      ],
      isPrimary: [this.currencyData?.isPrimary ?? false],
    });
  }

  onSubmit(): void {
    if (this.currencyData?.isPrimary) {
      this.toastr.warning('Primary currencies cannot be edited.');
      return;
    }
    if (!this.currencyData) {
      this.addCurrencyForm.markAllAsTouched();
      if (this.addCurrencyForm.valid) {
        const { currencyCode, currencyName, currencySymbol, exchangeRate } =
          this.addCurrencyForm.value;
        const createCurrencyInput = {
          currencyCode,
          currencyName,
          currencySymbol,
          exchangeRate: parseFloat(exchangeRate),
          isPrimary: false,
        };
        console.log(createCurrencyInput);
        // console.log(currencyName);
        // console.log(currencySymbol);
        // console.log(exchangeRate);
        
        this.currencyService.createCurrency(createCurrencyInput).subscribe({
          next: (response) => {
            this.toastr.success(
              'Currency Adjustment created successfully.',
              'Success'
            );
            this.dialogRef.close('success');
          },
          error: (error) => {
            this.errorMessage =
              'Failed to create currency adjustment. Please try again';
            if (error && error.message) {
              this.errorMessage = error.message;
            } else {
              this.errorMessage =
                'An unknown error occurred while creating currency adjustment.';
            }
            this.toastr.error(
              this.errorMessage ?? 'Failed to create currency adjustment'
            );
            this.loading = false;
          }
      });
      }
    } else {
      this.addCurrencyForm.markAllAsTouched();
      if (this.addCurrencyForm.valid) {
        const updateCurrencyInput = {
          ...this.addCurrencyForm.value,
          id: this.currencyData?.id,
          exchangeRate: parseFloat(this.addCurrencyForm.value.exchangeRate),
        };
        this.currencyService.updateCurrencyById(updateCurrencyInput).subscribe(
          (resonse) => {
            this.toastr.success(
              'Currency Adjustment updated successfully.',
              'Success'
            );
            this.dialogRef.close('success');
          },
          (error) => {
            this.errorMessage =
              'Failed to update currency adjustment. Please try again';
            if (error && error.message) {
              this.errorMessage = error.message;
            } else {
              this.errorMessage =
                'An unknown error occurred while updating currency adjustment.';
            }
            this.toastr.error(
              this.errorMessage ?? 'Failed to update currency adjustment'
            );
            this.loading = false;
          }
        );
      }
    }
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').toString().trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }

  onCancel() {
    this.addCurrencyForm.reset();
  }
}

@Component({
  selector: 'upload-adjustments-dialog',
  templateUrl: 'upload-adjustments-dialog.html',
  styleUrls: ['./currency-adjustments.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class UploadAdjustmentsDialog {
  file: any = null;
  url: any = null;
  loading: boolean = false;
  uploadForm: FormGroup;

  constructor(
    private toastr: ToastrService,
    private currencyService: CurrencyAdjustmentService,
    private dialogRef: DialogRef,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.uploadForm = this.fb.group({
      file: [null, Validators.required],
    });
    document.addEventListener('dragover', this.preventDefaultBehavior);
    document.addEventListener('drop', this.preventDefaultBehavior);
  }

  preventDefaultBehavior(event: DragEvent) {
    event.preventDefault();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
    this.uploadForm.get('file')!.updateValueAndValidity();
  }

  // uploadDocuments(csvFile: any) {
  //   this.loading = true;
  //   // this.currencyService.bulkCreateCurrency(csvFile).subscribe({
  //   //   next: (response) => {
  //   //     console.log(response);
  //   //     this.loading = false;
  //   //     if (response && !response.errors) {
  //   //       this.toastr.success(
  //   //         'Currency adjustments updated successfully!'
  //   //       );
  //   //       this.dialogRef.close();
  //   //     } else if (response?.errors) {
  //   //       this.toastr.error(response.errors[0]?.message, 'Error');
  //   //       this.dialogRef.close();
  //   //     }
  //   //   },
  //   //   error: (error) => {
  //   //     this.toastr.error(error, 'Bulk currency creation failed');
  //   //     this.dialogRef.close();
  //   //     this.loading = false;
  //   //   },
  //   // });
  // }

  removeFile(): void {
    this.file = null;
    const input = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    this.uploadForm.get('file')!.updateValueAndValidity();
  }

  onUpload() {
    if (this.uploadForm.invalid && !this.file) {
      this.uploadForm.markAllAsTouched();
      return;
    }
    // this.uploadDocuments(this.file);
  }

  ngOnDestroy() {
    document.removeEventListener('dragover', this.preventDefaultBehavior);
    document.removeEventListener('drop', this.preventDefaultBehavior);
  }
}
